var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 70,
    viewBox: "0 0 78 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88 69.015H69.12C75.28 69.015 79.12 62.335 76.04 57.015L45.92 4.97499C42.84 -0.345015 35.16 -0.345015 32.08 4.97499L1.96 57.015C-1.12 62.335 2.72 69.015 8.88 69.015ZM39 41.015C36.8 41.015 35 39.215 35 37.015V29.015C35 26.815 36.8 25.015 39 25.015C41.2 25.015 43 26.815 43 29.015V37.015C43 39.215 41.2 41.015 39 41.015ZM35 57.015H43V49.015H35V57.015Z",
    fill: "#FF7F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.578f31d87c30379464654013d8d681cf.svg";
export { ForwardRef as ReactComponent };